import { createTheme } from '@mui/material/styles';

/**
 * VoltPassport admin theme. Tuned for mobile-first:
 *   - Touch-friendly default sizes (min 44px tap targets)
 *   - Compact dense breakpoints so tablet-sized screens get desktop layouts
 *   - Brand blue + safety green palette
 */
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#0d6efd' },
    secondary: { main: '#198754' },
    error: { main: '#d32f2f' },
    background: { default: '#f5f6fa', paper: '#ffffff' }
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: { fontSize: '2rem', fontWeight: 600 },
    h2: { fontSize: '1.5rem', fontWeight: 600 },
    h3: { fontSize: '1.25rem', fontWeight: 600 }
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', minHeight: 44 }
      }
    },
    MuiTextField: {
      defaultProps: { fullWidth: true, size: 'medium' }
    },
    MuiListItemButton: {
      styleOverrides: { root: { minHeight: 48 } }
    }
  }
});
